import React from 'react';
import './Daily.css';

const Daily = () => {
  // Mock data - replace with your backend API calls
  const dailyData = {
    recap: "Yesterday you were feeling frustrated but you want to continue working towards feeling excitement",
    moonPhase: {
      phase: "Plant seeds 🌱",
      message: "This is a time for new beginnings and setting intentions. Allow yourself to dream and plant the seeds of what you wish to cultivate."
    },
    dasha: {
      current: "Jup-Sat-Mars",
      message: "Tune into that voice within and notice if things seem more clear. The combination of Jupiter's wisdom, Saturn's discipline, and Mars' action creates a powerful foundation for inner knowing."
    },
    helpfulTip: "Working towards your goal of getting fit, try out the Brazilian technique of 'movimento natural' - incorporating playful, animal-like movements into your daily routine for just 10 minutes.",
    story: "The ancients believed in the power of daily ritual to anchor the soul. Each morning, Persian mystics would spend time in contemplation, understanding that consistent small practices create profound transformation over time."
  };

  return (
    <div className="daily-container">
      <div className="content-wrapper">
        
        {/* Recap Section */}
        <section className="recap-section">
          <h2 className="section-title">Recap</h2>
          <p className="recap-text">{dailyData.recap}</p>
        </section>

        {/* Moon Phase Section */}
        <section className="moon-section">
          <div className="moon-header">
            <span className="moon-phase">{dailyData.moonPhase.phase}</span>
          </div>
          <p className="moon-message">{dailyData.moonPhase.message}</p>
        </section>

        {/* Dasha Section */}
        <section className="dasha-section">
          <div className="dasha-header">
            <span className="dasha-current">{dailyData.dasha.current}</span>
          </div>
          <p className="dasha-message">{dailyData.dasha.message}</p>
        </section>

        {/* Helpful Tip Section */}
        <section className="tip-section">
          <p className="tip-text">{dailyData.helpfulTip}</p>
        </section>

        {/* Story Section */}
        <section className="story-section">
          <p className="story-text">{dailyData.story}</p>
        </section>

      </div>
    </div>
  );
};

export default Daily;